import React from 'react';

import { locale } from '@trqk/utils';

import { footerHeight } from '../../constants';

/**
 * Shows a simple label like "Report Total" to add context to the rest of the footers.
 * @returns JSX
 */
export const ChannelFooter = (): JSX.Element => (
    <div className="flex items-center" style={{ height: footerHeight }}>
        <p className="pl-4">
            {
                locale.enUS.MANAGE_GAP_ANALYSIS.STEPS.CONFIRM_CHANNELS
                    .COLUMN_FOOTERS.CHANNEL
            }
        </p>
    </div>
);
